import React from "react";
import UserContextType from "../../../domain/providers/user/UserContextType";

export const defaultUserContext: UserContextType = {
    user: undefined,
    setUser: () => {}
};
const UserContext = React.createContext<UserContextType>(defaultUserContext);

export default UserContext;